'use strict'

module.exports = Backbone.View.extend
  events:
    'click .reset': '_triggerReset'
    'click .getaways_reset': '_triggerCalendarReset'

  render: (html) ->
    @$el.html html

  _triggerReset: ->
    @trigger 'reset'

  _triggerCalendarReset: ->
    @trigger 'calendarReset'
